// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_TV0","rootNoMargin":"styles_rootNoMargin__1eU3J"};